<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('categories')">Categoria</inertia-link>
      <span class="text-white font-medium">/       {{ form.name}} 
              </span>
    </h1>
 
    <img v-if="category.imageUrl" class="block ml-4 w-16 h-16 rounded-full" :src="category.imageUrl" @click="showModal"/>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-2/4" label="Nombre" required/>
          <file-input v-model="form.photo" :error="form.errors.photo" class="pr-6 pb-8 w-full lg:w-2/4" type="file" accept="image/*" label="Imagen" />
          <text-input v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full lg:w-1/1" label="Descripción"/>

        </div>
         <br>  
                <div v-if="mensagge" role="alert" class="mt-3 relative flex w-full p-3 text-sm text-white bg-black rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-5 w-5 mr-2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path></svg>
                {{mensagge}}
              </div>
              <br>  
        <div class="px-8 py-4 bg-transparent flex justify-between items-center">
          <button  class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Categoria</button>          
          <loading-button :loading="form.processing" style="color: white" class="px-8 py-4 btn-indigoOrange" type="submit">Actualizar Categoria</loading-button>
        </div>
      </form>
    </div>

    <Modal
  v-show="isModalVisible"
  @close="closeModal"
>
  <template v-slot:header>
   <!-- This is a new modal header.-->
  </template>

  <template v-slot:body>
       <img v-if="category.imageUrl"  :src="category.imageUrl" height="380px" width="300px"/>

  </template>

  <template v-slot:footer>
   <!-- This is a new modal footer.-->
  </template>
</Modal>
      
  </div>

</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import FileInput from '@/Shared/FileInput'
import Modal from '@/Shared/Modal.vue';

export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    FileInput,
    Modal,
  },
  layout: Layout,
  props: {
    category: Object,
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      isModalVisible: false,
      mensagge: '',
      form: this.$inertia.form({
        _method: 'put',
        id: this.category.id,
        name: this.category.name,
        description: this.category.description,
        photo: null,
        status: this.category.status,
      
      }),
    }
  },
  methods: {
      update() {
      this.form.post(`/categories/${this.category.id}`, {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('categories.destroy', this.category.id))
      }
    },
    showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      },
  },
}
</script>
